import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Card } from '../components/Card';
import { TabularNumber } from '../components/TabularNumber';
import { fmtUsd, microsToUsd } from '../lib/format';

interface LedgerRow { vendor: string; model: string | null; events: number; usd_micros: number; input_tokens: number; output_tokens: number }

export function AdminDashboard() {
  const [vendorRows, setVendorRows] = useState<LedgerRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void api.get<{ rows: LedgerRow[] }>('/v1/ledger/summary?group_by=vendor')
      .then((r) => setVendorRows(r.rows))
      .finally(() => setLoading(false));
  }, []);

  const totalMicros = vendorRows.reduce((s, r) => s + r.usd_micros, 0);

  return (
    <div className="max-w-6xl mx-auto px-6 py-10 space-y-8">
      <header>
        <h1 className="text-2xl tracking-tight">Workspace overview</h1>
        <p className="text-sm text-[color:var(--mute)] mt-1">Last 30 days · all engineers</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card title="Spend (30d)">
          <TabularNumber size="xl">{fmtUsd(microsToUsd(totalMicros))}</TabularNumber>
        </Card>
        <Card title="Vendors active">
          <TabularNumber size="xl">{vendorRows.length}</TabularNumber>
        </Card>
        <Card title="Events">
          <TabularNumber size="xl">
            {vendorRows.reduce((s, r) => s + r.events, 0).toLocaleString()}
          </TabularNumber>
        </Card>
      </div>

      <Card title="By vendor">
        {loading ? (
          <div className="text-[color:var(--mute)]">Loading…</div>
        ) : vendorRows.length === 0 ? (
          <div className="text-[color:var(--mute)]">No data yet. Connect a vendor account to start ingesting.</div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-widest text-[color:var(--mute)] border-b border-[color:var(--rule)]">
                <th className="py-2">Vendor</th>
                <th className="py-2 text-right">Events</th>
                <th className="py-2 text-right">Input tokens</th>
                <th className="py-2 text-right">Output tokens</th>
                <th className="py-2 text-right">Spend</th>
              </tr>
            </thead>
            <tbody>
              {vendorRows.map((r, i) => (
                <tr key={i} className="border-b border-[color:var(--rule)]">
                  <td className="py-3">{r.vendor}</td>
                  <td className="py-3 text-right num">{r.events.toLocaleString()}</td>
                  <td className="py-3 text-right num">{r.input_tokens.toLocaleString()}</td>
                  <td className="py-3 text-right num">{r.output_tokens.toLocaleString()}</td>
                  <td className="py-3 text-right num">{fmtUsd(microsToUsd(r.usd_micros))}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
